const FileReaderFactory = {
  make: () => new FileReader(),
};
export default FileReaderFactory;
